import React from "react";
import Layout from "../../components/signup-layout/index.tsx";

function SignUpClient() {
  return (
    <>
      <Layout
        title="Junte-se a nós e seja um Profissa ."
        subtitle="Precisamos de algumas informações antes de continuarmos!"
      />
    </>
  );
}

export default SignUpClient;
